import { useCallback } from 'react';
import { useStore, useStoreApi } from '../providers/store';
import type { FormParams } from '../stores/slices/task-form';
import type { FormTabType, ToolFormTabType } from '../types';

export const useMentionablePromptsData = (taskType: Exclude<FormTabType | ToolFormTabType, 'scene'>) => {
  const { updateFormParams } = useStore((state) => ({
    updateFormParams: state.updateFormParams,
  }));

  const store = useStoreApi();

  const updateTaskFormParams = useCallback(
    (key: keyof FormParams, params: FormParams[typeof key]) => {
      updateFormParams(taskType, key, params);
    },
    [updateFormParams, taskType],
  );

  const getFormParams = useCallback(() => {
    return store.getState()[`${taskType}FormParams`];
  }, [store, taskType]);

  const formParams = useStore((state) => state[`${taskType}FormParams`]);

  return {
    formParams,
    updateFormParams: updateTaskFormParams,
    getFormParams,
  };
};
